import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import type { Order } from '../../context';


interface OrderTableProps {
  orders: Order[];
  isLoading: boolean;
  onView: (order: Order) => void;
}

export function OrderTable({ orders, isLoading, onView }: OrderTableProps) {
  const theme = useTheme();

  const columns = [
    { 
      field: 'orderCode', 
      headerName: 'Código', 
      width: 120,
      renderCell: (params: any) => (
        <Typography 
          sx={{ 
            fontFamily: 'monospace', 
            fontSize: 12,
            backgroundColor: '#F3F4F6',
            color: '#111827',
            px: 1,
            py: 0.5,
            borderRadius: 1
          }}
        >
          {params.value}
        </Typography>
      )
    },
    { 
      field: 'origin', 
      headerName: 'Origem', 
      width: 120,
      renderCell: (params: any) => (
        <Typography fontSize={14}>{params.value}</Typography>
      )
    },
    { 
      field: 'recipientName', 
      headerName: 'Destinatário', 
      flex: 1,
      renderCell: (params: any) => (
        <Typography>{params.value}</Typography>
      )
    },
    { 
      field: 'userName', 
      headerName: 'Usuário', 
      width: 160,
      renderCell: (params: any) => (
        <Typography>{params.value}</Typography>
      )
    },
    { 
      field: 'receivedAt', 
      headerName: 'Recebida em', 
      width: 160,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {format(new Date(params.value), 'dd/MM/yyyy HH:mm', { locale: ptBR })}
        </Typography>
      )
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 120,
      renderCell: (params: any) => (
        <Chip
          label={
            params.value === 'PENDING'
              ? 'Recebido'
              : params.value === 'DELIVERED'
              ? 'Entregue'
              : params.value
          }
          color={
            params.value === 'PENDING'
              ? 'warning'
              : params.value === 'DELIVERED'
              ? 'success'
              : 'default'
          }
          size="small"
          variant="outlined"
        />
      )
    },
  ];
  
  const rows = orders.map(order => ({
    ...order,
    userName: order.user?.name || '',
  }));

  return (
    <DatabaseTable
      rows={rows as any}
      columns={columns}
      loading={isLoading}
      onView={onView as any}
      hideDelete
      hideEdit
    />
  );
}